export const enum ContactStatus {
    Invited = 1,
    Active = 2,
    Archived = 3
}